import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { QueuePrompt } from './components/QueuePrompt'
import { AuthGate } from './components/AuthGate'
import { CustomerProvider } from './lib/customer'
import '@fontsource-variable/nunito-sans'
import '@fontsource-variable/jetbrains-mono'
import '@fontsource/space-mono/400.css'
import '@fontsource/space-mono/700.css'
import './index.css'
import { loadDisplayFont } from './lib/fonts'
import { keepPasswordManagersToLogins } from './lib/autofill'

loadDisplayFont()
keepPasswordManagersToLogins()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthGate>
          <CustomerProvider>
            <App />
            <QueuePrompt />
          </CustomerProvider>
        </AuthGate>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
